var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-top mb-5"},[_c('h2',{staticClass:"title"},[_vm._v("May you like")]),_c('div',{staticClass:"line",staticStyle:{"margin-bottom":"24px"}}),_vm._l((_vm.randomItem),function(game){return _c('div',{key:game.id},[_c('router-link',{staticClass:"specific-game",class:{ 'dark-mode': _vm.darkMode },attrs:{"to":{
        name: 'GameDetail',
        params: {
          id: game.id,
          meta: game.title,
        },
      }}},[_c('SideGameCard',{attrs:{"game":game,"darkMode":_vm.darkMode}})],1)],1)}),(_vm.loading)?_c('Loading'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }